/* CC — collection infinite scroll (Derek).
 * Progressive enhancement over the theme's numbered pagination: fetches the
 * next page, appends its product cards into the current grid, and repeats as
 * the shopper nears the bottom. Falls back to the normal pagination when
 * IntersectionObserver is unavailable or JS is off.
 *
 * Hooks it relies on (theme-side):
 *   .collection-grid            the product grid (cards are its children)
 *   [data-cc-next]              the pagination "next" link (carries href)
 *   .element-pagination         the numbered pagination block (hidden when active)
 */
(function () {
  var grid = document.querySelector('.collection-grid');
  if (!grid || !('IntersectionObserver' in window) || !('fetch' in window)) return;

  function findNext(scope) {
    var a = (scope || document).querySelector('[data-cc-next]');
    var href = a && a.getAttribute('href');
    return href && href.indexOf('#') !== 0 ? href : null;
  }

  var nextUrl = findNext(document);
  if (!nextUrl) return; // single page — nothing to do

  // Hide the native numbered pagination. A ROOT class + CSS keeps it hidden even
  // if the theme re-renders the grid (which drops a per-element class), and also
  // hides any freshly-rendered pager.
  document.documentElement.classList.add('cc-inf-active');
  document.querySelectorAll('.element-pagination').forEach(function (p) { p.classList.add('cc-inf-hidden'); });

  // Status + sentinel after the grid.
  var wrap = document.createElement('div');
  wrap.className = 'cc-inf';
  var status = document.createElement('p');
  status.className = 'cc-inf__status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  var more = document.createElement('button');
  more.type = 'button';
  more.className = 'cc-inf__more';
  more.textContent = 'Load more';
  var sentinel = document.createElement('div');
  sentinel.className = 'cc-inf__sentinel';
  wrap.appendChild(status);
  wrap.appendChild(more);
  wrap.appendChild(sentinel);
  grid.after(wrap);

  var loading = false, done = false;

  function setStatus(msg) { status.textContent = msg || ''; }

  function reinit() {
    // Re-run app widgets on the freshly appended cards.
    try { if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') window.jdgm.customizeBadges(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cc:products-appended', { detail: { grid: grid } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('shopify:section:load')); } catch (e) {}
  }

  function loadMore() {
    if (loading || done || !nextUrl) return;
    loading = true;
    more.disabled = true;
    setStatus('Loading more…');
    fetch(nextUrl, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.collection-grid');
        var liveGrid = document.querySelector('.collection-grid') || grid; // re-query: the theme may have re-rendered it
        var anchor = liveGrid.querySelector('.element-pagination'); // keep pagination last
        var added = 0;
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (node) {
            if (node.classList && node.classList.contains('element-pagination')) return;
            if (anchor) liveGrid.insertBefore(node, anchor); else liveGrid.appendChild(node);
            added++;
          });
        }
        nextUrl = findNext(doc);
        loading = false;
        more.disabled = false;
        if (added) reinit();
        if (!nextUrl) {
          done = true;
          observer.disconnect();
          more.hidden = true;
          setStatus("You've reached the end.");
        } else {
          setStatus('');
        }
      })
      .catch(function () {
        loading = false;
        more.disabled = false;
        setStatus('Couldn’t load more — tap to retry.');
      });
  }

  more.addEventListener('click', loadMore);

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) loadMore(); });
  }, { rootMargin: '700px 0px' });
  observer.observe(sentinel);
})();
